import config from "./config"
import service from "@/utils/helper"
import allDataService from "@/utils/allDataHelper"

// 测试
export function test(params) {
  return service.post(
    `${config.BASE_URL}/customer-login/login-register-service`,
    params
  )
}
// 获取十月保贝进度
export function v3process(params) {
  return service.get(
    `${config.BASE_URL}/ThermometerV2/active/v3/ten-month-baby-process`,
    {
      params
    }
  )
}
// 获取十月保贝相关的 “一对一产品购买状态”
export function get1v1Status(params) {
  return service.get(
    `${config.BASE_URL}/ThermometerV2/api/v2/user/orderStatus1v1`,
    {
      params
    }
  )
}

/**
 * 获取九“月”孕成周期列表
*/
export const get9CyclesProcess = authToken => {
  return service.get(
    `${config.BASE_URL}/ThermometerV2/active/v3/nine-month-process-v2?authToken=${authToken}`
  )
}

/** 
 * 获取周期分析报告
 */
export const getAnalysisReport = (authToken, cycNo) => {
  return service.get(
    `${config.BASE_URL}/ThermometerV2/user/get_cycle_report_v2?authToken=${authToken}&cycleNumber=${cycNo}`
  )
}

/**
 * 签约九“月”孕成/十月保贝等
 */
export const signUp10Cycles = (authToken, params) => {
  return service.post(
    `${config.BASE_URL}/ThermometerV2/active/v3/sign?authToken=${authToken}`,
    params
  )
}

/**
 * 签约九“月”孕成/十月保贝等
 */
export const sign9CyclesPolicy = (authToken, params) => {
  return service.post(
    `${config.BASE_URL}/ThermometerV2/active/v3/sign-agreement?authToken=${authToken}`,
    params
  )
}

/**
 * 获取 九“月”孕成 协议版本
 */
export const get9CyclesVersion = (authToken) => {
  return service.get(
    `${config.BASE_URL}/ThermometerV2/active/v3/nine-month-private-version?authToken=${authToken}`
  )
}

/**
 * 获取十月保贝、九“月”孕成等状态
 */
export function v3status(params) {
  return service.get(
    `${config.BASE_URL}/ThermometerV2/active/v3/status`,
    {
      params
    }
  )
}

/**
 * 获取九“月”孕成退款状态
 */
export const refundStatus = (authToken) => {
  return service.get(
    `${config.BASE_URL}/ThermometerV2/active/v3/nine-month-refund?authToken=${authToken}`
  )
}

/** 
 * 获取用户的绑定老公状态等数据
 */
export const getUserInfo = (authToken) => {
  return service.get(
    `${config.BASE_URL}/ThermometerV2/api/user-info/login-info?authToken=${authToken}`
  )
}

/** 
 * 解绑老公
 */
export const unbindHusband = (authToken) => {
  return service.delete(
    `${config.BASE_URL}/ThermometerV2/api/user-info/unbind-relatives?authToken=${authToken}`
  )
}

// 
export function searchVideo(params) {
  return service.get(
    `${config.BASE_URL}/ThermometerV2/active/v3/status`,
    {
      params
    }
  )
}

// 获取任务内容
export function flptask(params) {
  return service.get(
    `${config.BASE_URL}/ThermometerV2/customer/flptask`,
    {
      params
    }
  )
}
// 上传任务结果
export function uploadTaskAnswer(params, token) {
  return service.post(
    `${config.BASE_URL}/ThermometerV2/customer-task-answer?authToken=${token}`, params
  )
}
// 获取 FLP 心理包内容列表
export function getPsyList(params, token) {
  return service.get(
    `${config.BASE_URL}/ThermometerV2/customer-psychology-task/list?authToken=${token}`, params
  )
}

// 统计
export function statistics(query, params) {
  return service.put(
    `${config.BASE_URL}/ThermometerV2/datacollection/statistics_common${query}`,
    params
  )
}
// 获取视频列表
export function getVideoList(params) {
  return service.get(
    `${config.SER_API}/internal-service/api/v1/webbbs/list`,
    {
      params
    }
  )
}
// 获取热门视频
export function getTop(params) {
  return service.get(
    `${config.SER_API}/internal-service/api/v1/webbbs/top`,
    {
      params
    }
  )
}
// 获取分组列表
export function getGroupList(params) {
  return service.get(
    `${config.SER_API}/internal-service/api/v1/group/list`,
    {
      params
    }
  )
}
export function getFirstGroupList(params) {
  return service.get(
    `${config.SER_API}/internal-service/api/v1/first-group/list`,
    {
      params
    }
  )
}
// 获取视频内容
export function getVideoDetail(params) {
  return service.get(
    `${config.SER_API}/internal-service/api/v1/webbbs/view`,
    {
      params
    }
  )
}
// 增加阅读次数
export function addRead(params) {
  return service.get(
    `${config.SER_API}/internal-service/api/v1/webbbs/read`,
    {
      params
    }
  )
}
// 增加点赞次数
export function addPraise(params) {
  return service.get(
    `${config.SER_API}/internal-service/api/v1/webbbs/praise`,
    {
      params
    }
  )
}

export function cancelPraise(params) {
  return service.get(
    `${config.SER_API}/internal-service/api/v1/webbbs/cancelPraise`,
    {
      params
    }
  )
}

// 获取oss临时token
export function getSecurityToken() {
  return service.get(
    `${config.BASE_URL}/ThermometerV2/gyna/getStsSecurityToken.json`
  )
}

// 获取文章列表
export function getArticleList(params) {
  return service.get(
    `${config.SER_API}/internal-service/api/v1/webbbs/label`,
    {
      params
    }
  )
}

// 获取文章标签列表
export function getLabelList(params) {
  return service.get(
    `${config.SER_API}/internal-service/api/v1/webbbs/label/list`,
    {
      params
    }
  )
}

/**
 * 上传 调研 等答案
 */
export const uploadAnswers = (params) => {
  return service.post(
    `${config.BASE_URL}/ThermometerV2/v3/op-activity/put-new-activity`,
    params
  )
}

/** 
 * 获取文章阅读数
 */
export const getKnowledgeReadNum = (id, authToken) => {
  return service.get(
    `${config.BASE_URL}/ThermometerV2/api/v3/preg/get-page-read-num?id=${id}&authToken=${authToken}`
  )
}

/** 
 * 阅读文章
 */
export const readKnowledge = (id, authToken) => {
  return service.get(
    `${config.BASE_URL}/ThermometerV2/api/v3/preg/incre-page-read-num?id=${id}&authToken=${authToken}`
  )
}

// 获取vip code状态
export const vipV3status = (authToken, params) => {
  return service.post(
    `${config.BASE_URL}/ThermometerV2/api/v3/vip?authToken=${authToken}`,
    params
  )
}

/** 
 * 优孕师读图运营页：发送评论
 */
export const sendComment = (authToken, params) => {
  return service.post(
    `${config.BASE_URL}/ThermometerV2/api/v3/comments/send-comment?authToken=${authToken}`,
    params
  )
}

/** 
 * 优孕师读图运营页：点赞
 */
export const sendPraise = (authToken, praise, titleId) => {
  return service.get(
    `${config.BASE_URL}/ThermometerV2/api/v3/comments/send-praise?authToken=${authToken}&titleId=${titleId}&praise=${praise}`
  )
}

/** 
 * 优孕师读图运营页：获取评论和点赞数据
 */
export const getComments = (authToken, titleId, page) => {
  let url = `${config.BASE_URL}/ThermometerV2/api/v3/comments/get-all?titleId=${titleId}&pageNum=${page}&pageSize=20`
  if (authToken) {
    url += `&authToken=${authToken}`
  }
  return service.get(
    url
  )
}

/** 
 * 优孕师读图文章列表
 */
export const getAllReadSamples = () => {
  let url = `${config.BASE_URL}/ThermometerV2/api/v3/comments/get-all-read-samples`
  return service.get(
    url
  )
}
// 获取胎心记录详情
export function getBabySoundDetail(params) {
  return service.get(
    `${config.BASE_URL}/ThermometerV2/api/v3/hardware/baby-sound-detail`,
    {
      params
    }
  )
}

/**
 * 获取新用户优孕师状态
 */
export const checkUserPregnantMasterStatus = (authToken) => {
  return service.get(
    `${config.BASE_URL}/ThermometerV2/api/v3/read-pic/check-user-send?authToken=${authToken}`
  )
}

/**
 * 新用户领取优孕师
 */
export const newUserPregnantMaster = (authToken) => {
  return service.get(
    `${config.BASE_URL}/ThermometerV2/api/v3/read-pic/new-user-send-count?authToken=${authToken}`
  )
}

/**
 * 获取 优孕师读图 用户分层
*/
export const getPregnantMasterDefaultID = (authToken) => {
  return service.get(
    `${config.BASE_URL}/ThermometerV2/api/v3/comments/get-pre-read-sample?authToken=${authToken}&pageNum=0&pageSize=2`
  )
}

/** 
 * 优孕师读图运营页：获取文章内容、轮播图、评论和点赞数据
 */
export const getPregnantMasterContent = (titleId, page, authToken) => {
  let url = `${config.BASE_URL}/ThermometerV2/api/v3/comments/get-sample-comment-and-info?titleId=${titleId}&pageNum=${page}&pageSize=20`
  if (authToken) {
    url += `&authToken=${authToken}`
  }
  return service.get(
    url
  )
}

/**
 * 开启测温打卡计划
 */
export const multySignUp = (authToken, params) => {
  return service.post(
    `${config.BASE_URL}/ThermometerV2/active/v3/multy-sign?authToken=${authToken}`,
    params
  )
}

/**
 * 通过权益开启测温打卡计划
 */
export const multySignUpByRights = (authToken, params) => {
  return service.post(
    `${config.BASE_URL}/ThermometerV2/active/v3/multy-sign-by-rights?authToken=${authToken}`,
    params
  )
}


/**
 * 获取测温打卡计划
 */
export const getMultySignUp = (authToken) => {
  return service.get(`${config.BASE_URL}/ThermometerV2/active/v3/multy-sign?authToken=${authToken}&activeType=21`)
}

// 获取wxjssdk配置
export function getWxJsSdkConfig(params) {
  return service.get(
    `${config.SER_API}/wechat/wxservice/api/v1/get-jsapi-info?url=${params}`
  )
}

/**
 * 获取加小助手状态
 */
export const checkWxFriends = (authToken) => {
  return service.get(`${config.BASE_URL}/ThermometerV2/active/v3/check-add-yc-friend?authToken=${authToken}`)
}

/**
 * 获取加群状态
 */
export const checkWxGroup = (authToken) => {
  return service.get(`${config.BASE_URL}/ThermometerV2/api/v3/qywechat/check-jia-qun?authToken=${authToken}`)
}

/**
 * 获取 app config
*/
export const getAppConfig = (authToken) => {
  return service.get(
    `${config.BASE_URL}/ThermometerV2/api/v3/vip/vip-config?authToken=${authToken}`
  )
}

export const getAppConfigByHeader = (authToken) => {
  return service.get(
    `${config.BASE_URL}/ThermometerV2/api/v3/vip/vip-config?authToken=${authToken}&h5=h5`)
}

/**
 * 兑换VIP
 */
export const exchangeVip = (authToken, params) => {
  return service.post(
    `${config.BASE_URL}/ThermometerV2/active/v3/exchange-yc-vip?authToken=${authToken}`,
    params
  )
}

/**
 * 获取 vip 评论列表
*/
export const getVipCommentList = (authToken) => {
  return service.get(
    `${config.BASE_URL}/ThermometerV2/api/v3/comments/quanjiatong-comment?authToken=${authToken}`
  )
}

/**
 * 获取商品列表
*/
export const getGoodList = () => {
  return service.get(
    `${config.MALL_BASE_URL}/api/goods`
  )
}

/**
 * 获取胎心监测服务
 */
export const getMonitorInfo = (authToken) => {
  return service.get(`${config.BASE_URL}/ThermometerV2/chunwei/get-monitor-info?authToken=${authToken}`)
}

export const getMonitorDetail = (authToken, deviceId) => {
  return service.get(`${config.BASE_URL}/ThermometerV2/chunwei/get-monitor-info?authToken=${authToken}&id=${deviceId}`)
}

/**
 * 获取所有胎心监测服务
 */
export function getAllMonitorServices() {
  return service.get(`${config.BASE_URL}/ThermometerV2/chunwei/get-monitor-services`)
}

/**
 * 上传图片到 OSS
 */
export function uploadFile(token, path, fileName, file) {
  const formData = new FormData()
  formData.append('file', file, fileName)
  const header = {
    headers: {
      'content-type': 'multipart/form-data'
    }
  }
  return service.put(
    `${config.BASE_URL}/ThermometerV2/api/file/upload-sync?authToken=${token}&path=${path}`,
    formData,
    header
  )
}

/**
 * 上传签名图片链接到用户绑定的设备信息里
 */
export function chunweiSign(authToken, imgUrl, protocolNo) {
  return service.post(
    `${config.BASE_URL}/ThermometerV2/chunwei/chunwei-sign?authToken=${authToken}`,
    {
      signUrl: imgUrl,
      signNumber: protocolNo
    }
  )
}

/**
 * 设备退回
 */
export const monitorRefund = (authToken, params) => {
  return service.post(
    `${config.BASE_URL}/ThermometerV2/chunwei/monitor-refund?authToken=${authToken}`,
    params
  )
}

/**
 * 获取用户数据
 */
export const getUserStatus = (authToken) => {
  return service.get(`${config.BASE_URL}/ThermometerV2/api/v2/user/status?authToken=${authToken}`)
}

export const weChatLogin = (data) => {
  return allDataService.post(`${config.BASE_URL}/ThermometerV2/login/loginThird.json`,data)
}


/**
 * 提交生育力调查问券
 */
export const postQuestionFertility = (authToken, params) => {
  return service.post(
    `${config.BASE_URL}/ThermometerV2/api/v3/questionnaire/fertility-v2?authToken=${authToken}`,
    params
  )
}
/*
 * 获取生育力调查问券答案
 */
export const getQuestionFertility = (authToken) => {
  return service.get(`${config.BASE_URL}/ThermometerV2/api/v3/questionnaire/fertility?authToken=${authToken}`)
}
/**
 * 提交助孕器调查问券
 */
export const postQuestionAid = (authToken, params) => {
  return service.post(
    `${config.BASE_URL}/ThermometerV2/api/v3/questionnaire/fertility-aid-v2?authToken=${authToken}`,
    params
  )
}
/*
 * 获取助孕器调查问券答案
 */
export const getQuestionAid = (authToken) => {
  return service.get(`${config.BASE_URL}/ThermometerV2/api/v3/questionnaire/fertility-aid?authToken=${authToken}`)
}

/**
 * 获取手机验证码
 */
export const getVeriCode = (params) => {
  return service.post(`${config.BASE_URL}/ThermometerV2/veri/getCodeV3`, params)
}
/**
 * 上传手机号
 */
export const acceptInvitation = (params) => {
  return service.post(`${config.BASE_URL}/ThermometerV2/lit-api/recom-friend`, params)
}

/**
 * 获取邀请记录
 */
export const getInviteRecord = (authToken) => {
  return service.get(`${config.BASE_URL}/ThermometerV2/lit-api/recom-friend?authToken=${authToken}`)
}

export const getInGroup = (authToken) => {
  return service.get(`${config.BASE_URL}/ThermometerV2/api/v3/qywechat/check-jia-qun-v2?authToken=${authToken}`)
}

/**
 * 领取优惠券
*/
export const getGoodCoupon = (authToken, goodId, source) => {
  return service.get(
    `${config.MALL_BASE_URL}/api/coupons/get-coupon?authToken=${authToken}&goodId=${goodId}&source=${source}`
  )
}

/**
 * 获取产检列表信息
*/
export const getPregCheckList = (authToken) => {
  return service.get(
    `${config.BASE_URL}/ThermometerV2/v3/preg-report/report-list?authToken=${authToken}`
  )
}

export const getPregCheckInfo = (authToken, id) => {
  return service.get(
    `${config.BASE_URL}/ThermometerV2/v3/preg-report/report-list-one?authToken=${authToken}&id=${id}`
  )
}

export const getPregBabyRemind = (authToken) => {
  return service.get(
    `${config.BASE_URL}/ThermometerV2/api/v3/pre-prag-article/get-baby-change-info?version=0&force=0&authToken=${authToken}`
  )
}

/**
 * 获取用户分层数据，用于推荐不同产品：全家桶 或 试纸套装
*/
export const getUserLabel = (authToken) => {
  return service.get(
    `${config.BASE_URL}/ThermometerV2/active/v3/user-info-for-config?authToken=${authToken}`
  )
}

/**
 * 未孕报告
*/
export const getNoPregReport = (authToken) => {
  return service.get(
    `${config.BASE_URL}/ThermometerV2/api/v3/report/get-no-preg-report?authToken=${authToken}`
  )
}

export const getNoPregReportHusband = (authToken) => {
  return service.get(
    `${config.BASE_URL}/ThermometerV2/api/v3/report/get-no-preg-husband-report?authToken=${authToken}`
  )
}
/**
 * 优惠卷信息
*/
export const getConponInfo = (authToken,goodId,source,time) => {
  return service.get(
    `${config.MALL_BASE_URL}/api/coupons/get-coupon-info?authToken=${authToken}&goodId=${goodId}&source=${source}&time=${time}`
  )
}

/**
 * 获取优惠卷
*/
export const getCoupon = (authToken,goodId,source) => {
  return service.get(
    `${config.MALL_BASE_URL}/api/coupons/get-coupon?authToken=${authToken}&goodId=${goodId}&source=${source}`
  )
}

/**
 * 获取用户的商城收货地址
*/
export const getAddressList = (params) => {
  return service.post(
    `${config.MALL_BASE_URL}/api/address/getAddressByOpenid`,
    params
  )
}

/**
 * 添加收货地址
 * @return
 */
export const addAddress = (params) => {
  return service.post(
    `${config.MALL_BASE_URL}/api/address/insertAddress`,
    params
  )
}

/**
 * 获取该用户有无测温打卡权益
*/
export const getUserRightsTestBBT = (authToken) => {
  return service.get(
    `${config.BASE_URL}/ThermometerV2/api/v2/user/user-rights-test-bbt?authToken=${authToken}`
  )
}

/**
 * 获取该用户所有孕期数据
*/
export const getUserPregData = (authToken) => {
  return service.get(
    `${config.BASE_URL}/ThermometerV2/api/v3/preg/get-preg-info?authToken=${authToken}`
  )
}


/**
 * 获取该用户标签
*/
export const getUserTags = (userid) => {
  return service.get(
    `${config.SER_API}/internal-service/api/v1/label/get-one-user-label?userId=${userid}`
  )
}

export const getPregnantAdvice = (authToken) => {
  return service.get(
    `${config.BASE_URL}/ThermometerV2/user/get-pregnant-advice?authToken=${authToken}`
  )
}

export const getAides = (source) => {
  return service.get(
    `${config.SER_API}/internal-service/api/v1/aides/get-aides?source=${source}`
  )
}

export const getProductVideo = (type,id) => {
  return service.get(
    `${config.SER_API}/internal-service/api/web/video/product-video-by-key?key=${type}&id=${id}`
  )
}


export const getPregMasterQrCode = (status,source,unionId) => {
  return service.get(
    `${config.SER_API}/internal-service/api/v1/aides/get-aides?status=${status}&source=${source}&unionId=${unionId}`
  )
}

export const getActivityList = (authToken) => {
  return service.get(
    `${config.BASE_URL}/ThermometerV2/api/v3/activity/list?authToken=${authToken}`
  )
}

export const checkActivityStatus = (id, authToken) => {
  return service.get(
    `${config.BASE_URL}/ThermometerV2/api/v3/activity/check-receive-status?activityId=${id}&authToken=${authToken}`
  )
}

export const activityReceiveGood = (authToken, params) => {
  return service.post(`${config.BASE_URL}/ThermometerV2/api/v3/activity/receive-good?authToken=${authToken}`, params)
}

/**
 * 获取每个商品详情
 * @return
 */
export const fetchGoodDetail = (id) => {
  return service.get(
    `${config.MALL_BASE_URL}/api/goods/getGoodById/?id=${id}`
  )
}

//创建订单
export const confirmOrderApi = (authToken,params) => {
  return service.post(`${config.MALL_BASE_URL}/api/order?authToken=${authToken}`, params)
}

/**
 * 微信环境，获取用户 订阅号未认证使用服务号接口，wechatUnionId
 * @return
 */

export const fetchWechatUnionId = (code) => {
  return service.get(`https://apiserver.shecarefertility.com/wechat/wxservice/api/v1/unionid?code=${code}`)
}

export const checkFshPlan = (authToken) => {
  return service.get(
    `${config.BASE_URL}/ThermometerV2/api/v3/detector/plan?authToken=${authToken}`
  )
}

export const preFshPlan = (authToken, ova, ovf) => {
  return service.get(
    `${config.BASE_URL}/ThermometerV2/api/v3/detector/pre-plan?authToken=${authToken}&ova=${ova}&ovf=${ovf}`
  )
}

export const saveFshPlan = (authToken, ova, ovf) => {
  return service.post(
    `${config.BASE_URL}/ThermometerV2/api/v3/detector/plan?authToken=${authToken}&ova=${ova}&ovf=${ovf}`
  )
}